import { colors } from '@/constants/colors';
import React from 'react';
import { styled } from 'styled-components';

interface Props {
   active: boolean;
}

const OptionBtn = ({ active }: Props) => {
   return (
      <Wrapper>
         <BorderWrapper $active={active}>
            <Indicator $active={active} />
         </BorderWrapper>
      </Wrapper>
   );
};

const Wrapper = styled.div``;

const BorderWrapper = styled.div<{ $active: boolean }>`
   width: 20px;
   height: 20px;
   border-radius: 100px;
   /* border: 2px solid ${colors.GRAY11}; */
   border: 2px solid
      ${({ $active }) => ($active ? colors.PRIMARY : colors.GRAY11)};
   display: flex;
   align-items: center;
   justify-content: center;
`;

const Indicator = styled.div<{ $active: boolean }>`
   width: 10px;
   height: 10px;
   border-radius: 100px;
   background-color: ${({ $active }) => ($active ? colors.PRIMARY : 'none')};
   /* background-color: ${colors.PRIMARY}; */
`;

export default OptionBtn;
